import { createAction } from 'redux-actions';

export const camDxLogin = createAction('CAM_DX_LOGIN');
export const camDxVerify = createAction('CAM_DX_VERIFY');
export const camDxVerifyError = createAction('CAM_DX_VERIFY_ERROR');
